import React from 'react';
import { Grid, Icon, makeStyles, colors } from '@material-ui/core';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';

import {
  PasswordValidator,
  PasswordValidatorFields,
} from 'domain/authentication/usecases/SignUpFormValidator';

import Description from 'components/typography/Description';

import PasswordInput from './PasswordInput';

const useStyles = makeStyles({
  icon: {
    color: colors.red[400],
  },
  disabledIcon: {
    color: 'rgba(0,0,0,0.32)',
  },
  description: {
    color: 'rgba(0,0,0,0.72)',
  },
  disabledDescription: {
    color: 'rgba(0,0,0,0.32)',
  },
});

const PasswordInputWithValidation = ({ value, onChange, errorMessage }) => {
  return (
    <Grid container direction="column" spacing={4}>
      <Grid item container>
        <PasswordInput
          value={value}
          onChange={onChange}
          errorMessage={errorMessage}
        ></PasswordInput>
      </Grid>

      <Grid item container direction="column" spacing={2}>
        <Grid item>
          <ValidationField
            field={PasswordValidatorFields.length}
            value={value}
          ></ValidationField>
        </Grid>

        <Grid item>
          <ValidationField
            field={PasswordValidatorFields.number}
            value={value}
          ></ValidationField>
        </Grid>

        <Grid item>
          <ValidationField
            field={PasswordValidatorFields.lowerCase}
            value={value}
          ></ValidationField>
        </Grid>

        <Grid item>
          <ValidationField
            field={PasswordValidatorFields.upperCase}
            value={value}
          ></ValidationField>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapFieldToDescription = (field) => {
  if (field === PasswordValidatorFields.length)
    return (
      <span>
        Must have length greater or equal than <b>8</b>
      </span>
    );

  if (field === PasswordValidatorFields.number)
    return (
      <span>
        Must have a <b>number</b>
      </span>
    );

  if (field === PasswordValidatorFields.lowerCase)
    return (
      <span>
        Must have a <b>lower case</b> letter
      </span>
    );

  if (field === PasswordValidatorFields.upperCase)
    return (
      <span>
        Must have a <b>upper case</b> letter
      </span>
    );

  throw new Error('field cannot be empty');
};

const ValidationField = ({ value, field }) => {
  const classes = useStyles();
  const passwordValidator = PasswordValidator(value);
  const isValid = passwordValidator[field];

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <Check value={isValid}></Check>
      </Grid>

      <Grid item style={{ marginTop: -4 }}>
        <Description>
          <span
            className={
              isValid ? classes.description : classes.disabledDescription
            }
          >
            {mapFieldToDescription(field)}
          </span>
        </Description>
      </Grid>
    </Grid>
  );
};

const Check = ({ value }) => {
  const classes = useStyles();

  return (
    <Icon className={value ? classes.icon : classes.disabledIcon}>
      {value ? (
        <CheckBox></CheckBox>
      ) : (
        <CheckBoxOutlineBlank></CheckBoxOutlineBlank>
      )}
    </Icon>
  );
};

export default PasswordInputWithValidation;
